import { useState, useEffect, useRef } from 'react';

// canDismiss lets a caller decide which outside clicks really mean dismiss me.
export default function useComponentFocused(initialIsFocused: boolean, canDismiss?: (event: MouseEvent) => boolean) {
  const [isComponentFocused, setIsComponentFocused] = useState(initialIsFocused);
  const ref = useRef<HTMLElement | null>(null);

  // Assign popupRef to the popup element that should not trigger the outside click.
  const popupRef = useRef<HTMLElement | null>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (canDismiss && !canDismiss(event)) {
      return;
    }
    if (
      ref.current &&
      !ref.current.contains(event.target as Node) &&
      !(popupRef.current && popupRef.current.contains(event.target as Node))
    ) {
      setIsComponentFocused(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return { ref, popupRef, isComponentFocused, setIsComponentFocused };
}
